/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  DeliveryReceiptRequestDto,
  EmailReceiptDto,
  ErrorMessage,
  F1TerminalSoftpayReceiptDto,
  PosReceiptResponseDto,
  PrintReceiptDto,
  ReceiptSuccessDto,
  SoftpayReceiptDto,
} from '../models';
import {
    DeliveryReceiptRequestDtoFromJSON,
    DeliveryReceiptRequestDtoToJSON,
    EmailReceiptDtoFromJSON,
    EmailReceiptDtoToJSON,
    ErrorMessageFromJSON,
    ErrorMessageToJSON,
    F1TerminalSoftpayReceiptDtoFromJSON,
    F1TerminalSoftpayReceiptDtoToJSON,
    PosReceiptResponseDtoFromJSON,
    PosReceiptResponseDtoToJSON,
    PrintReceiptDtoFromJSON,
    PrintReceiptDtoToJSON,
    ReceiptSuccessDtoFromJSON,
    ReceiptSuccessDtoToJSON,
    SoftpayReceiptDtoFromJSON,
    SoftpayReceiptDtoToJSON,
} from '../models';

export interface EmailReceiptRequest {
    reference: string;
    emailReceiptDto: EmailReceiptDto;
}

export interface GetF1TerminalReceiptRequest {
    paymentReference: string;
}

export interface GetPosReceiptRequest {
    reference: string;
}

export interface GetReceiptRequest {
    paymentReference: string;
}

export interface PrintDeliveryReceiptRequest {
    reference: string;
    placementId: number;
    deliveryReceiptRequestDto: DeliveryReceiptRequestDto;
}

export interface PrintReceiptRequest {
    reference: string;
    printReceiptDto: PrintReceiptDto;
}

/**
 * 
 */
export class ReceiptControllerApi extends runtime.BaseAPI {

    /**
     */
    async emailReceiptRaw(requestParameters: EmailReceiptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReceiptSuccessDto>> {
        if (requestParameters.reference === null || requestParameters.reference === undefined) {
            throw new runtime.RequiredError('reference','Required parameter requestParameters.reference was null or undefined when calling emailReceipt.');
        }

        if (requestParameters.emailReceiptDto === null || requestParameters.emailReceiptDto === undefined) {
            throw new runtime.RequiredError('emailReceiptDto','Required parameter requestParameters.emailReceiptDto was null or undefined when calling emailReceipt.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/digital-bills/{reference}/email-receipt`.replace(`{${"reference"}}`, encodeURIComponent(String(requestParameters.reference))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EmailReceiptDtoToJSON(requestParameters.emailReceiptDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReceiptSuccessDtoFromJSON(jsonValue));
    }

    /**
     */
    async emailReceipt(requestParameters: EmailReceiptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReceiptSuccessDto> {
        const response = await this.emailReceiptRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getF1TerminalReceiptRaw(requestParameters: GetF1TerminalReceiptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<F1TerminalSoftpayReceiptDto>> {
        if (requestParameters.paymentReference === null || requestParameters.paymentReference === undefined) {
            throw new runtime.RequiredError('paymentReference','Required parameter requestParameters.paymentReference was null or undefined when calling getF1TerminalReceipt.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v2/softpay/{paymentReference}/receipt`.replace(`{${"paymentReference"}}`, encodeURIComponent(String(requestParameters.paymentReference))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => F1TerminalSoftpayReceiptDtoFromJSON(jsonValue));
    }

    /**
     */
    async getF1TerminalReceipt(requestParameters: GetF1TerminalReceiptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<F1TerminalSoftpayReceiptDto> {
        const response = await this.getF1TerminalReceiptRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getPosReceiptRaw(requestParameters: GetPosReceiptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PosReceiptResponseDto>> {
        if (requestParameters.reference === null || requestParameters.reference === undefined) {
            throw new runtime.RequiredError('reference','Required parameter requestParameters.reference was null or undefined when calling getPosReceipt.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/digital-bills/{reference}/pos-receipt`.replace(`{${"reference"}}`, encodeURIComponent(String(requestParameters.reference))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PosReceiptResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async getPosReceipt(requestParameters: GetPosReceiptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PosReceiptResponseDto> {
        const response = await this.getPosReceiptRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getReceiptRaw(requestParameters: GetReceiptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SoftpayReceiptDto>> {
        if (requestParameters.paymentReference === null || requestParameters.paymentReference === undefined) {
            throw new runtime.RequiredError('paymentReference','Required parameter requestParameters.paymentReference was null or undefined when calling getReceipt.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/softpay/{paymentReference}/receipt`.replace(`{${"paymentReference"}}`, encodeURIComponent(String(requestParameters.paymentReference))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SoftpayReceiptDtoFromJSON(jsonValue));
    }

    /**
     */
    async getReceipt(requestParameters: GetReceiptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SoftpayReceiptDto> {
        const response = await this.getReceiptRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async printDeliveryReceiptRaw(requestParameters: PrintDeliveryReceiptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReceiptSuccessDto>> {
        if (requestParameters.reference === null || requestParameters.reference === undefined) {
            throw new runtime.RequiredError('reference','Required parameter requestParameters.reference was null or undefined when calling printDeliveryReceipt.');
        }

        if (requestParameters.placementId === null || requestParameters.placementId === undefined) {
            throw new runtime.RequiredError('placementId','Required parameter requestParameters.placementId was null or undefined when calling printDeliveryReceipt.');
        }

        if (requestParameters.deliveryReceiptRequestDto === null || requestParameters.deliveryReceiptRequestDto === undefined) {
            throw new runtime.RequiredError('deliveryReceiptRequestDto','Required parameter requestParameters.deliveryReceiptRequestDto was null or undefined when calling printDeliveryReceipt.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/digital-bills/{reference}/{placementId}/delivery-receipt`.replace(`{${"reference"}}`, encodeURIComponent(String(requestParameters.reference))).replace(`{${"placementId"}}`, encodeURIComponent(String(requestParameters.placementId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DeliveryReceiptRequestDtoToJSON(requestParameters.deliveryReceiptRequestDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReceiptSuccessDtoFromJSON(jsonValue));
    }

    /**
     */
    async printDeliveryReceipt(requestParameters: PrintDeliveryReceiptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReceiptSuccessDto> {
        const response = await this.printDeliveryReceiptRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async printReceiptRaw(requestParameters: PrintReceiptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReceiptSuccessDto>> {
        if (requestParameters.reference === null || requestParameters.reference === undefined) {
            throw new runtime.RequiredError('reference','Required parameter requestParameters.reference was null or undefined when calling printReceipt.');
        }

        if (requestParameters.printReceiptDto === null || requestParameters.printReceiptDto === undefined) {
            throw new runtime.RequiredError('printReceiptDto','Required parameter requestParameters.printReceiptDto was null or undefined when calling printReceipt.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/digital-bills/{reference}/print-receipt`.replace(`{${"reference"}}`, encodeURIComponent(String(requestParameters.reference))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PrintReceiptDtoToJSON(requestParameters.printReceiptDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReceiptSuccessDtoFromJSON(jsonValue));
    }

    /**
     */
    async printReceipt(requestParameters: PrintReceiptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReceiptSuccessDto> {
        const response = await this.printReceiptRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
